import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import logo from '../assets/logo.svg';
import { openContact } from '../utils/contact';
import './Navbar.css';

const APP_URL = process.env.REACT_APP_APP_URL || 'https://app.libbenincorp.com';

export default function Navbar() {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  // Ancoras so funcionam na Home. Fora dela, apontamos de volta para a secao.
  const links = [
    { key: 'features', href: isHome ? '#features' : '/#features' },
    { key: 'modules', href: isHome ? '#modules' : '/#modules' },
    { key: 'pricing', href: isHome ? '#pricing' : '/#pricing' },
    { key: 'faq', href: isHome ? '#faq' : '/#faq' },
  ];

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <a href="/" className="navbar-logo" aria-label="LibbenIncorp — inicio">
          <img src={logo} alt="LibbenIncorp" className="navbar-logo-img" />
        </a>

        <ul className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          {links.map(({ key, href }) => (
            <li key={key}>
              <a href={href} onClick={closeMenu}>{t(`nav.${key}`)}</a>
            </li>
          ))}
        </ul>

        <div className="navbar-actions">
          <a href={`${APP_URL}/login`} className="btn-ghost">{t('nav.login')}</a>
          <button type="button" onClick={openContact} className="btn-primary">{t('nav.demo')}</button>
          <button
            className="btn-menu"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Abrir menu"
            aria-expanded={menuOpen}
          >
            {menuOpen ? '✕' : '☰'}
          </button>
        </div>
      </div>
    </nav>
  );
}
